import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function() {
  return <CircularProgress />;
}
